import { useEffect, useState } from 'react';
import {
  getSubscribers,
  deleteSubscriber,
  isMissingTable,
} from '../services/adminApi';
import DataTable from '../components/DataTable';
import ConfirmDialog from '../components/ConfirmDialog';
import MissingTable from '../components/MissingTable';

export default function Newsletter() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const load = async () => {
    const { data, error } = await getSubscribers();
    setRows(data);
    setError(error);
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  if (error && isMissingTable(error))
    return <MissingTable table="newsletter_subscribers" />;

  const copyEmails = () => {
    navigator.clipboard.writeText(rows.map((r) => r.email).join(', '));
    alert(`Copied ${rows.length} email addresses to clipboard.`);
  };

  const handleDelete = async () => {
    setDeleting(true);
    const { error } = await deleteSubscriber(deleteTarget.id);
    setDeleting(false);
    setDeleteTarget(null);
    if (error) alert(`Delete failed: ${error.message}`);
    load();
  };

  return (
    <div>
      <div className="page-head">
        <h1>Newsletter Subscribers</h1>
        {rows.length > 0 && (
          <button className="btn-primary" onClick={copyEmails}>
            📋 Copy all emails
          </button>
        )}
      </div>

      {error && !isMissingTable(error) && (
        <p className="admin-error">Failed to load: {error.message}</p>
      )}

      <DataTable
        loading={loading}
        emptyMessage="No subscribers yet."
        columns={[
          { key: 'email', label: 'Email' },
          {
            key: 'created_at',
            label: 'Subscribed On',
            render: (r) =>
              r.created_at
                ? new Date(r.created_at).toLocaleDateString('en-IN', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                  })
                : '—',
          },
          {
            key: 'actions',
            label: '',
            width: '100px',
            render: (r) => (
              <button className="btn-delete" onClick={() => setDeleteTarget(r)}>
                Remove
              </button>
            ),
          },
        ]}
        rows={rows}
      />

      <ConfirmDialog
        open={!!deleteTarget}
        title="Remove subscriber?"
        message={`${deleteTarget?.email} will be removed from the mailing list.`}
        confirmLabel="Remove"
        busy={deleting}
        onConfirm={handleDelete}
        onCancel={() => setDeleteTarget(null)}
      />
    </div>
  );
}
